import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { d as debounce_1 } from './index4.js';
import './index2.js';
import { D as DomService } from './index3.js';

const rocheOffcanvasPanelCss = ":host{z-index:350;display:block;position:fixed;inset:0;pointer-events:none}:host .slide{display:block;position:absolute;top:0;right:0;width:100%;height:100%;min-height:100%;overflow:auto;overflow-x:hidden;touch-action:pan-y;background-color:#fff;opacity:0;transform:translateY(-25%);transition:opacity 300ms cubic-bezier(0.65, 0, 0.35, 1), transform 500ms cubic-bezier(0.23, 0, 0.56, 0.99)}:host(.open){pointer-events:all}:host(.open) .slide{opacity:1;transform:translateY(0);transition:opacity 400ms cubic-bezier(0.65, 0, 0.35, 1), transform 300ms cubic-bezier(0, 0, 0, 1)}";
const RocheOffcanvasPanelStyle0 = rocheOffcanvasPanelCss;

const RocheOffcanvasPanel$1 = /*@__PURE__*/ proxyCustomElement(class RocheOffcanvasPanel extends HTMLElement {
    handleOffcanvasTrigger({ detail }) {
        const { offcanvasId, triggerId } = detail;
        if (this.element.getAttribute('id') !== offcanvasId) {
            if (this.open) {
                this.open = false;
                this.sendVisibilityChangeEvent('close', this.element.getAttribute('id'));
            }
            return;
        }
        if (this.open) {
            this.sendVisibilityChangeEvent('close', offcanvasId, triggerId);
            this.open = false;
            DomService.unlockBody();
        }
        else {
            DomService.lockBody();
            this.open = true;
            this.sendVisibilityChangeEvent('open', offcanvasId, triggerId);
            if (detail === 'roche-offcanvas-search') {
                const inputElement = this.element.querySelector('roche-search').shadowRoot.querySelector('input');
                inputElement.focus();
            }
        }
    }
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.open = false;
        this.handleBackgroundClick = this.handleBackgroundClick.bind(this);
        this.handleOffcanvasTrigger = debounce_1.debounce(this.handleOffcanvasTrigger.bind(this), 50, true);
    }
    render() {
        return (h(Host, { key: '07037f49e139f33982fe3d1275622c48287126be', class: { open: this.open } }, h("div", { key: '750db5a05c308628fbe982df6a887d09ac94b895', class: { background: true }, onClick: this.handleBackgroundClick }), h("div", { key: 'ddae43b36c943d69b4371e0396d1f5c4f6c5319b', class: "slide" }, h("slot", { key: 'd0d23b84d729dd7056436dfd6251f4d6c38ec0d4' }))));
    }
    handleBackgroundClick() {
        this.open = false;
        DomService.unlockBody();
        this.sendVisibilityChangeEvent('close', this.element.getAttribute('id'));
    }
    // eslint-disable-next-line class-methods-use-this
    sendVisibilityChangeEvent(state, offcanvasId, triggerId) {
        window.dispatchEvent(new CustomEvent('rocheOffcanvasVisibilityChange', {
            detail: {
                offcanvasId,
                state,
                triggerId,
            },
        }));
    }
    get element() { return this; }
    static get style() { return RocheOffcanvasPanelStyle0; }
}, [1, "roche-offcanvas-panel", {
        "open": [1540]
    }, [[8, "rocheOffcanvasTrigger", "handleOffcanvasTrigger"]]]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["roche-offcanvas-panel"];
    components.forEach(tagName => { switch (tagName) {
        case "roche-offcanvas-panel":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RocheOffcanvasPanel$1);
            }
            break;
    } });
}

const RocheOffcanvasPanel = RocheOffcanvasPanel$1;
const defineCustomElement = defineCustomElement$1;

export { RocheOffcanvasPanel, defineCustomElement };

//# sourceMappingURL=roche-offcanvas-panel.js.map